import React, { useRef, useEffect } from 'react'
import { Button, Input, Icon, Spin, Progress } from 'antd'
import classNames from 'classnames'
import { ImagePreview } from '../../../../../../../components'

const LocationItem = ({
  locationKey,
  description,
  isPending,
  locationReference,
  isGeneratingLocationReference,
  generatingKeys,
  loadingTip,
  onEdit,
  onDelete,
  onSave,
  onCancelEdit,
  editingKey,
  editValue,
  setEditValue,
  locationGenerationProgress,
  locationGenerationStatus
}) => {
  const editRef = useRef(null)

  const refs = locationReference || {}
  const refKey = refs[`__${locationKey}__`] ? `__${locationKey}__` : locationKey
  const reference = refs[refKey]
  const imageSrc =
    reference &&
    (reference.uri || reference.url || reference.image || reference.src)
  const tag = reference && (reference.tag || reference.name)

  const isItemGenerating =
    isGeneratingLocationReference &&
    (generatingKeys === 'ALL' ||
      (Array.isArray(generatingKeys) && generatingKeys.includes(locationKey)))

  useEffect(() => {
    if (editingKey === locationKey) {
      setTimeout(() => {
        try {
          if (
            editRef &&
            editRef.current &&
            typeof editRef.current.focus === 'function'
          )
            editRef.current.focus()
        } catch (e) {
          // ignore
        }
      }, 0)
    }
  }, [editingKey, locationKey])

  return (
    <div
      className={classNames('lr-item-card', {
        'is-generating': isItemGenerating,
        'is-pending': isPending
      })}
      style={{
        opacity:
          isGeneratingLocationReference && !isItemGenerating && generatingKeys
            ? 0.6
            : 1
      }}
    >
      <div className="lr-item-overlay">
        <Spin
          tip={
            loadingTip ||
            (locationGenerationProgress
              ? `${locationGenerationProgress}% ${locationGenerationStatus ||
                  'Generating...'}`
              : 'Regenerating...')
          }
        />
      </div>

      <div className="lr-item-thumbnail">
        {isGeneratingLocationReference && !imageSrc ? (
          <>
            <Spin
              tip={
                loadingTip ||
                (locationGenerationProgress
                  ? `${locationGenerationStatus ||
                      'Generating...'} ${locationGenerationProgress}% `
                  : 'Regenerating...')
              }
            />
          </>
        ) : imageSrc ? (
          <ImagePreview src={imageSrc} alt={tag || locationKey} />
        ) : isPending ? (
          <div className="draft-placeholder">
            <Icon type="edit" />
            <span>Draft</span>
          </div>
        ) : (
          <div className="no-image-placeholder">
            <Icon type="picture" />
            <span>No Image</span>
          </div>
        )}
      </div>

      <div className="lr-item-content">
        <div className="lr-item-header">
          <div className="lr-item-titles">
            <span className="lr-item-key" title={locationKey}>
              {locationKey}
            </span>
            {tag && <span className="lr-item-tag">({tag})</span>}
            {isPending && <span className="lr-item-badge">Draft</span>}
          </div>

          {!editingKey && (
            <div className="lr-item-actions">
              <Button
                size="small"
                onClick={() => onEdit(locationKey, description)}
                disabled={isGeneratingLocationReference}
              >
                Edit
              </Button>
              <Button
                size="small"
                danger
                onClick={() => onDelete(locationKey)}
                disabled={isGeneratingLocationReference}
              >
                Delete
              </Button>
            </div>
          )}
        </div>

        {editingKey === locationKey ? (
          <div className="lr-item-editor">
            <Input.TextArea
              ref={editRef}
              value={editValue}
              onChange={e => setEditValue(e.target.value)}
              rows={4}
              style={{ width: '100%' }}
            />
            <div className="lr-edit-actions">
              <Button
                type="primary"
                size="small"
                onClick={() => onSave(locationKey)}
              >
                Save
              </Button>
              <Button size="small" onClick={onCancelEdit}>
                Cancel
              </Button>
            </div>
          </div>
        ) : (
          <div className="lr-item-description">{String(description)}</div>
        )}
      </div>
    </div>
  )
}

export default LocationItem
